module.exports = __webpack_public_path__ + "img/22.439671aa.png";